import React from 'react';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import _ from 'lodash';
import Notification from 'app/components/general/Notification';

interface INotification {
  closed: boolean;
  message: any;
  actionType: string;
  actionLink: string;
}

interface IManageTeamNotificationsProps {
  actions: object;
  currentTeam: any;
}

interface IManageTeamNotificationsState {
  notifications: {
    [key: string]: INotification;
  };
  notificationTotal?: number;
  changed?: boolean;
}

export default class ManageTeamNotifications extends React.Component<
  IManageTeamNotificationsProps,
  IManageTeamNotificationsState
> {
  static defaultProps = {
    actions: undefined,
    currentTeam: undefined,
  };

  readonly state: IManageTeamNotificationsState = {
    notifications: {},
    changed: false,
  };

  static getDerivedStateFromProps(props, state): any {
    if (state.changed) {
      return state;
    }
    if (
      props.currentTeam
      && !state.changed
      && (_.isEmpty(props.currentTeam.group)
        || _.isEmpty(props.currentTeam.group.id))
    ) {
      return {
        notifications: {
          connect: {
            closed: false,
            message: (
              <span>
                <span role="img" aria-label="Connect">
                  🔗
                </span>
                {' '}
                Connect your team to your association so you can manage payments
                &amp; submit forfeits.
                {' '}
                <Link className="primary" to="/connect-team">
                  Connect now &gt;
                </Link>
              </span>
            ),
            actionType: 'navigate',
            actionLink: '/connect-team',
          },
        },
        notificationTotal: 1,
      };
    }
    return {
      notifications: {},
      notificationTotal: 0,
    };
  }

  handleClose = (key): void => {
    this.setState((previousState) => {
      const notificationBoolean = !previousState.notifications[key].closed;
      const notificationAmount = !notificationBoolean ? 1 : -1;
      const newState = {
        notifications: {
          ...previousState.notifications,
          [key]: {
            ...previousState.notifications[key],
            closed: notificationBoolean,
          },
        },
        notificationTotal: previousState.notificationTotal + notificationAmount,
        changed: true,
      };
      return newState;
    });
  };

  renderNotifications = (notificationList: any): React.ReactNode => _.map(notificationList, (notification, notificationKey) => {
    if (!notification.closed) {
      switch (notification.actionType) {
        case 'navigate':
          return (
            <Notification
              id={notificationKey}
              key={notificationKey}
              handleClose={this.handleClose}
              onClick={(): any => history.push(notification.actionLink)}
            >
              {notification.message}
            </Notification>
          );
        default:
          return null;
      }
    }
    return null;
  });

  render(): React.ReactNode {
    const notificationList: any = this.state.notifications;
    if (this.state.notificationTotal > 0) {
      return (
        <div className="row with-margin-bottom">
          <div className="col">
            <h3>Notifications</h3>
            <div className="notifications-list">
              {this.renderNotifications(notificationList)}
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}
